import { render, staticRenderFns } from "./investor.vue?vue&type=template&id=e85b6906&scoped=true&"
import script from "./investor.vue?vue&type=script&lang=js&"
export * from "./investor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e85b6906",
  null
  
)

export default component.exports